export const WIZARD_PAGES = [
    'personal',
    'goals',
    'current-state',
    'keywords',
    'education',
    'jobs',
    'courses',
    'skills',
    'languages',
    'soft-skills',
];